<div class="gaze-page-container">
  <!-- Gaze Header -->
  <header class="gaze-header">
    <div class="back-btn-container">
      <button class="back-btn" (click)="OnClickClose()" aria-label="Go back">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="#2d6a70" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    <div class="gaze-logo-wrapper">
      <h1 class="gaze-logo">Gaze</h1>
      <span class="gaze-sublogo">
         <span class="by-text">by</span> WindowSwap</span>
    </div>
    <div class="gaze-page-subtitle">{{ constants.GAZE_DELETE_ACCOUNT_CONTENT.headerTitle }}</div>
  </header>

  <!-- Gaze Content Body -->
  <main class="gaze-content-body">
    <div class="gaze-content-container">
      
      <!-- Top Description -->
      <p class="top-description">{{ constants.GAZE_DELETE_ACCOUNT_CONTENT.description }}</p>

      <!-- How to Delete Steps Section -->
      <section class="steps-section">
        <h2 class="section-title">{{ constants.GAZE_DELETE_ACCOUNT_CONTENT.howToDelete.title }}</h2>
        <ol class="step-list">
          <li *ngFor="let step of constants.GAZE_DELETE_ACCOUNT_CONTENT.howToDelete.steps; let i = index">
            <span class="step-num">{{ i + 1 }}</span>
            <span class="step-text">{{ step }}</span>
          </li>
        </ol>
      </section>

      <!-- Important Callout Box -->
      <div class="important-callout">
        <div class="callout-header">
          <span class="callout-title">
            <svg class="warning-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 3c.8 0 1.5.4 1.9 1.1l9 15.6c.4.7.4 1.6 0 2.3-.4.7-1.1 1.1-1.9 1.1H3c-.8 0-1.5-.4-1.9-1.1s-.4-1.6 0-2.3l9-15.6C10.5 3.4 11.2 3 12 3z" fill="#8C381A"/>
              <path d="M12 8V14" stroke="#FFFFFF" stroke-width="2.2" stroke-linecap="round"/>
              <circle cx="12" cy="17.5" r="1.25" fill="#FFFFFF"/>
            </svg>
            {{ constants.GAZE_DELETE_ACCOUNT_CONTENT.important.title }}
          </span>
        </div>
        <ul class="callout-list">
          <li *ngFor="let item of constants.GAZE_DELETE_ACCOUNT_CONTENT.important.items">{{ item }}</li>
        </ul>
      </div>

      <!-- What Data Will Be Deleted Section -->
      <section class="deleted-data-section">
        <h2 class="section-title">{{ constants.GAZE_DELETE_ACCOUNT_CONTENT.whatWillBeDeleted.title }}</h2>
        <p class="deleted-data-subtitle">{{ constants.GAZE_DELETE_ACCOUNT_CONTENT.whatWillBeDeleted.subtitle }}</p>
        <ul class="bullet-list">
          <li *ngFor="let item of constants.GAZE_DELETE_ACCOUNT_CONTENT.whatWillBeDeleted.items">{{ item }}</li>
        </ul>
        <p class="highlighted-footer-text">{{ constants.GAZE_DELETE_ACCOUNT_CONTENT.whatWillBeDeleted.footer }}</p>
      </section>

      <!-- Standard Gaze Footer -->
      <footer class="gaze-footer">
        <p class="footer-company">{{ constants.GAZE_FOOTER_CONTENT.footer.company }}</p>
        <p class="footer-copyright">{{ constants.GAZE_FOOTER_CONTENT.footer.copyright }}</p>
      </footer>

    </div>
  </main>
</div>
